import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPolishingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "polishing-sm" }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M92.15,61.56a.44.44,0,0,0,0-.16h0l-.06-.15,0,0L92,61.1l0,0A.69.69,0,0,0,91.8,61L76,51.82A28.61,28.61,0,0,0,79.89,38.3c0-4.6-1.66-7.8-4.32-9.24h0L64.38,22.6l-.49-.29,0,0c-2.57-1.37-6.07-1.1-9.92,1.12C47.7,27,42.41,34.67,40.47,42.18L8.2,60.81a.69.69,0,0,0-.13.11l0,0-.07.1,0,0-.06.15h0a.47.47,0,0,0,0,.17h0v4.32a.73.73,0,0,0,.36.63l41.57,24a.76.76,0,0,0,.72,0L91.8,66.53a.73.73,0,0,0,.36-.63V61.56Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M64.75,49.5a2.24,2.24,0,0,0,1.11-.33A4.72,4.72,0,0,0,68,45.42a1.82,1.82,0,0,0-.84-1.68,1.84,1.84,0,0,0-1.82.16,4.71,4.71,0,0,0-2.17,3.75A1.8,1.8,0,0,0,64,49.3l.06,0A1.46,1.46,0,0,0,64.75,49.5Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M92.63,61.51a.73.73,0,0,0,0-.22l0-.07a.67.67,0,0,0-.1-.21l0-.06a1.1,1.1,0,0,0-.14-.18l0-.05a.87.87,0,0,0-.22-.17L75.79,51.16l-.24.43c-.23.41-.47.82-.72,1.22l-.26.42L89,61.58,50.13,84.05,11,61.43,38.79,45.37A21.68,21.68,0,0,0,38.62,48c0,4.85,1.73,8.46,4.85,10.15l11.4,6.58.31.19.09,0a1.1,1.1,0,0,0,.47.1,1.05,1.05,0,0,0,.47-2l-.07,0L56.05,63,56,63,44.49,56.33C42.07,55,40.73,52.07,40.73,48c0-8.69,6.16-19.32,13.73-23.69,3.4-2,6.58-2.35,8.93-1.09a3.88,3.88,0,0,1,.46.27L75,29.92a1.05,1.05,0,1,0,1.13-1.78L64.94,21.71c-.18-.12-.37-.23-.59-.35-3-1.6-6.89-1.2-10.94,1.14-6.53,3.78-12.09,11.88-14,19.76L8,60.39a1,1,0,0,0-.23.18l-.06.06a1.09,1.09,0,0,0-.13.17l0,.06a1.39,1.39,0,0,0-.1.26.87.87,0,0,0,0,.25v4.38a1.2,1.2,0,0,0,.6,1l41.57,24a1.21,1.21,0,0,0,1.2,0L92,66.94a1.2,1.2,0,0,0,.6-1V61.51ZM92,61.1Zm-1.73,2.56v1.55L51.33,87.67V86.13ZM48.93,86.13v1.54L9.76,65.06V63.51ZM8,61.05Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M55.22,41.3a1.2,1.2,0,0,0,1.64-.41A33.59,33.59,0,0,1,59,37.83,1.2,1.2,0,0,0,57,36.37a35.65,35.65,0,0,0-2.23,3.28,1.17,1.17,0,0,0-.14.91A1.21,1.21,0,0,0,55.22,41.3Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M52.56,54.77a21.67,21.67,0,0,1,.32-3.6,1.19,1.19,0,0,0-1-1.39,1.16,1.16,0,0,0-.9.2,1.21,1.21,0,0,0-.49.77,23.56,23.56,0,0,0-.36,4A1.19,1.19,0,0,0,51.36,56,1.2,1.2,0,0,0,52.56,54.77Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M53,58.28a1.16,1.16,0,0,0-.55-.73,1.21,1.21,0,0,0-.91-.13,1.2,1.2,0,0,0-.86,1.46,10.75,10.75,0,0,0,1.81,3.89,1.2,1.2,0,0,0,1,.47,1.18,1.18,0,0,0,.72-.24,1.21,1.21,0,0,0,.23-1.69A8.57,8.57,0,0,1,53,58.28Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M80.8,35.05a1.2,1.2,0,0,0-2.36.45,15.35,15.35,0,0,1,.25,2.8c0,.25,0,.5,0,.75a1.18,1.18,0,0,0,.32.86,1.17,1.17,0,0,0,.83.39h.05a1.2,1.2,0,0,0,1.2-1.15c0-.29,0-.57,0-.85A17.78,17.78,0,0,0,80.8,35.05Zm-.93,5Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M73.75,29.62a5.91,5.91,0,0,1,1.25.49,6.08,6.08,0,0,1,2.27,2.21,1.2,1.2,0,0,0,1,.58,1.15,1.15,0,0,0,.62-.18,1.2,1.2,0,0,0,.4-1.65,8.16,8.16,0,0,0-4.95-3.77A1.2,1.2,0,0,0,73,29.06,1.18,1.18,0,0,0,73.75,29.62Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M66.63,30.82a1.26,1.26,0,0,0,.54-.13,12.47,12.47,0,0,1,3.3-1.14,1.2,1.2,0,0,0,1-1.4,1.2,1.2,0,0,0-1.4-1,14.92,14.92,0,0,0-3.93,1.35,1.19,1.19,0,0,0-.6.7,1.16,1.16,0,0,0,.06.91A1.19,1.19,0,0,0,66.63,30.82Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M60.51,35.4a1.22,1.22,0,0,0,.86-.36,24.6,24.6,0,0,1,2.74-2.43,1.2,1.2,0,0,0-1.45-1.91,27.32,27.32,0,0,0-3,2.66,1.2,1.2,0,0,0-.34.85,1.16,1.16,0,0,0,.36.84A1.21,1.21,0,0,0,60.51,35.4Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M77.38,49.06a1.19,1.19,0,0,0-1.6.55A36.19,36.19,0,0,1,74,52.84a1.21,1.21,0,0,0,.36,1.66,1.26,1.26,0,0,0,.65.19,1.19,1.19,0,0,0,1-.56,36.77,36.77,0,0,0,1.94-3.46,1.22,1.22,0,0,0,.06-.92A1.19,1.19,0,0,0,77.38,49.06Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M67.41,60.71a1.15,1.15,0,0,0-.9.2c-.49.34-1,.66-1.49,1a14.75,14.75,0,0,1-1.63.83,1.2,1.2,0,0,0,.48,2.3,1.12,1.12,0,0,0,.48-.1,18.29,18.29,0,0,0,1.87-1c.56-.32,1.12-.68,1.67-1.07a1.17,1.17,0,0,0,.49-.77,1.15,1.15,0,0,0-.2-.9A1.17,1.17,0,0,0,67.41,60.71Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M73.5,55.67a1.21,1.21,0,0,0-1.69.18,29.81,29.81,0,0,1-2.49,2.73,1.19,1.19,0,0,0,0,1.69,1.17,1.17,0,0,0,.86.37,1.21,1.21,0,0,0,.83-.33,31.94,31.94,0,0,0,2.7-3A1.21,1.21,0,0,0,73.5,55.67Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M79.63,41.73a1.2,1.2,0,0,0-1.42.93,27.35,27.35,0,0,1-1,3.54,1.22,1.22,0,0,0,.05.92,1.19,1.19,0,0,0,.69.61,1,1,0,0,0,.39.07,1.21,1.21,0,0,0,1.14-.8,30,30,0,0,0,1.08-3.85A1.2,1.2,0,0,0,79.63,41.73Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M60.94,63.88a1.13,1.13,0,0,0-.88-.26,6.76,6.76,0,0,1-3.21-.39,1.21,1.21,0,0,0-1.56.68A1.2,1.2,0,0,0,56,65.46a8.7,8.7,0,0,0,3.25.6A10.09,10.09,0,0,0,60.31,66a1.19,1.19,0,0,0,.81-.43,1.21,1.21,0,0,0,.26-.88A1.18,1.18,0,0,0,60.94,63.88Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M54.54,42.57a1.22,1.22,0,0,0-.92,0,1.17,1.17,0,0,0-.67.62,32,32,0,0,0-1.45,3.71,1.2,1.2,0,0,0,1.14,1.57,1.2,1.2,0,0,0,1.14-.83,29.16,29.16,0,0,1,1.35-3.44A1.22,1.22,0,0,0,54.54,42.57Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M47,47l-3.57.4A6.51,6.51,0,0,1,37.51,45l-2.24-2.81h0a.8.8,0,0,0-1.42.58l.41,3.58a6.54,6.54,0,0,1-2.43,5.86L29,54.43a.79.79,0,0,0,.59,1.41l3.57-.4A6.51,6.51,0,0,1,39,57.87l2.24,2.81a.79.79,0,0,0,.62.31.87.87,0,0,0,.31-.07.78.78,0,0,0,.49-.82l-.41-3.58a6.56,6.56,0,0,1,2.43-5.87l2.82-2.24A.79.79,0,0,0,47,47Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M29.85,43.4a.59.59,0,0,0,.22,0,.58.58,0,0,0,.36-.6l-.25-2.19a3.91,3.91,0,0,1,1.45-3.5l1.72-1.37a.58.58,0,0,0-.42-1l-2.19.25a3.9,3.9,0,0,1-3.5-1.46l-1.38-1.72a.57.57,0,0,0-.67-.17.59.59,0,0,0-.36.6l.25,2.19a3.9,3.9,0,0,1-1.45,3.5l-1.72,1.37a.58.58,0,0,0,.43,1L24.52,40A3.89,3.89,0,0,1,28,41.46l1.37,1.72A.58.58,0,0,0,29.85,43.4Z"
			})
		]
	})]
});
export default SvgPolishingSm;
